import React, { useEffect, useState } from 'react';
import './index.scss';
import { Modal, Table } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { HttpStatusCode } from '@/fetch/core/constant';
import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';
import { getClstag } from '@/utils/util';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';

const CallFrontLiner = (props: { vehicleName: string }) => {
  const [open, setOpen] = useState(false);
  const [selectUser, setSelectUser] = useState(0);
  const [currentPhone, setCurrentPhone] = useState(null);
  const cockpitMode = useSelector(
    (state: RootState) => state.newCommon?.cockpitMode
  );
  const [tableData, setTableData] = useState<
    {
      userName: any;
      realName: string;
      phone: any;
    }[]
  >([]);

  const getTableList = () => {
    request({
      path: '/monitor/web/attention/getAttentionUser',
      method: Method.POST,
      body: {
        vehicleName: props.vehicleName,
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        setTableData(res.data || []);
      }
    });
  };

  const resetTableData = (list: any, updateSecret: Function) => {
    if (!list) {
      return [];
    }
    const newList: any[] = list.map((item: any) => {
      if (typeof item.secret === 'undefined') {
        item.secret = true;
      }
      return {
        ...item,
        phone: { item, updateSecret },
      };
    });
    return newList;
  };
  const getPhone = async () => {
    const res: any = await request({
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/attention/getStationPersonPhone`,
      method: Method.POST,
      body: {
        vehicleName: props.vehicleName,
      },
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
    });

    if (res.code === HttpStatusCode.Success) {
      setCurrentPhone(res.data.phone);
    }
  };
  const updatePhoneSecret = (userName: any, secret: any) => {
    setTableData(
      tableData.map((item: any) => {
        if (item.userName === userName) {
          return {
            ...item,
            secret: secret,
          };
        } else {
          return {
            ...item,
            secret: true,
          };
        }
      })
    );
  };

  useEffect(() => {
    getTableList();
    return () => {};
  }, []);

  const toggleShowOrHide = (userName: any, rowData: any) => {
    setSelectUser(userName);
  };
  const columns: any[] = [
    {
      dataIndex: 'userName',
      title: '姓名/erp',
      align: 'center',
      render: (text: string, record: any) => {
        const realName = String(record.realName);
        const erp = String(record.erp);
        const fullName = realName + '/' + erp;
        const encryptionName =
          realName.replace(realName.substring(1, realName.length), '****') +
          '/' +
          erp.replace(erp.substring(1, erp.length), '****');
        return (
          <>
            {selectUser === record.userName ? (
              <div
                className="encryption"
                onClick={toggleShowOrHide.bind(null, 0, record)}
              >
                {fullName}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeOutlined />
                </span>
              </div>
            ) : (
              <div
                className="encryption"
                onClick={toggleShowOrHide.bind(null, record.userName, record)}
              >
                {encryptionName}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeInvisibleOutlined />
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      dataIndex: 'phone',
      title: '手机号',
      align: 'center',
      render: (params: any, record: any) => {
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            {!params.item.secret && currentPhone
              ? currentPhone
              : params.item.phone}
            <div
              style={{ paddingLeft: '5px' }}
              onClick={() => {
                if (params.item.secret) {
                  getPhone();
                }
                params.updateSecret(record.userName, !params.item.secret);
                setCurrentPhone(null);
              }}
            >
              {params.item.secret ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <li
        className="btn-item callfront"
        onClick={() => {
          setOpen(true);
        }}
        clstag={getClstag(cockpitMode, 'SinglePage_CallFrontliner')}
      >
        <i>呼叫一线</i>
      </li>
      <Modal
        width={800}
        open={open}
        title={'呼叫一线'}
        okText="确定"
        cancelText="取消"
        onOk={() => {
          setOpen(false);
        }}
        onCancel={() => {
          setOpen(false);
        }}
      >
        <Table
          rowKey={'userName'}
          columns={columns}
          dataSource={resetTableData(tableData, (userName: any, secret: any) =>
            updatePhoneSecret(userName, secret)
          )}
          pagination={false}
          scroll={{
            y: '647px',
          }}
        ></Table>
      </Modal>
    </>
  );
};

export default React.memo(CallFrontLiner);
